export const MuiTabs = {
  styleOverrides: {
    flexContainer: {
      alignItems: "stretch",
      height: "100%",
    },
    indicator: {
      height: "3px",
    },
  },
};
